import React from 'react'
import imageLogo from "../../../images/movies-logo-en.png";
//import LoginContainer from "../LoginContainer";

const Navbar  = ({authenticated, username, loginVisible, onToggleLoginVisibility, onOrder}) => {
    return (
        <header>
            <nav>
                <div className="box">
                    <a className="logo" href="http://www.mooveez.com">
                        <img src={imageLogo} alt="mooveez - enjoy languages"/>
                        <span>mooveez</span>
                    </a>

                    <ul>
                        <li className="icon-user"><a onClick={onOrder} className="btn"> objednejte zde</a></li>
                        {/*
                        <li className="icon-help"><a href=""> nápověda </a></li>
                        {authenticated
                            ?
                            <li className="login"><span>{username}</span></li>
                            :
                            <li className="login" onClick={onToggleLoginVisibility}><span> přihlášení </span>
                                {loginVisible && <LoginContainer/>}
                            </li>
                        }
                        <li><span className="icon-mobile"></span></li> */}
                    </ul>
                </div>
            </nav>

        <nav id="sub-navigation">
            <div className="box">
                <div>
                    <a href=""><strong>Homepage</strong></a>
                </div>
                <div>
                    <strong>Pro školy</strong>
                    <ul>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                    </ul>
                </div>
                <div>
                    <strong>Pro učitele</strong>
                    <ul>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                    </ul>
                </div>
                <div className="last">
                    <strong>Pro firmy</strong>
                    <ul>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                        <li><a href="">link</a></li>
                    </ul>
                </div>
                <br className="cl"/>
            </div>
        </nav>
        </header>
    );
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/main/view/Navbar.jsx